import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlertService } from '@core/services/alert/alert.service';

@Injectable({
    providedIn: 'root'
})
export class FormUtilitiesService {
    // This flag indicates if all fields in the form are visible and identified.
    // If any field that is not visible or hidden is present in the form, this flag will be set to false.
    allFieldIdentified: boolean = true;

    constructor(private alertService: AlertService) {}

    applyServerFieldErrors(form: FormGroup, fieldErrors: Record<string, string[]>): void {
        this.allFieldIdentified = true;
        form.enable();
        for (const [fieldName, messages] of Object.entries(fieldErrors)) {
            const control = form.get(fieldName);
            if (!control) {
                this.allFieldIdentified = false;
                console.warn(
                    `Field "${fieldName}" not found in the form. Please ensure all fields are correctly identified.`
                );
                continue;
            }

            if (control.disabled) {
                control.enable({ emitEvent: false });
            }

            //This is a workaround to ensure the errors are applied to the control.
            //Im not sure why this is needed, but the error is applied only after this timeout.
            //See https://github.com/angular/angular/issues/38191
            setTimeout(() => {
                control.setErrors({ server: messages.join('\n') });
                control.markAsTouched();
                control.markAsDirty();
            }, 1);
        }
        form.updateValueAndValidity();

        if (!this.allFieldIdentified) {
            this.alertService.showError(
                'Form Error',
                'Please try again. If this issue persist, please contact support. This may be due to a bug or an issue with the form configuration.'
            );
        }
    }
}
